import React from "react";
import ShareImageModal from "Global/ShareImageModal";

interface ShareTradeTriggerProps {
  trigger: JSX.Element;
  visible: boolean;
  openModal: () => void;
  closeModal: () => void;
  shareTradeImageUrl?: string;
  onClick?: () => void;
  imageTitle?: string;
}

const ShareTradeTrigger = ({
  trigger,
  visible,
  openModal,
  closeModal,
  shareTradeImageUrl,
  imageTitle,
  ...props
}: ShareTradeTriggerProps) => {
  return (
    <>
      {React.cloneElement(trigger, {
        ...props,
        onClick: () => {
          (props as any).onClick && (props as any).onClick();
          openModal();
        },
      })}
      {visible && (
        <div
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <ShareImageModal
            visible={visible}
            closeModal={closeModal}
            imageUrl={shareTradeImageUrl}
            imageTitle={imageTitle}
          />
        </div>
      )}
    </>
  );
};

export default ShareTradeTrigger;
